import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	message: "",
	choosenbyuser: {
		isMariana: false,
		isBrumadinho: false
	},
	isAdmin: false,
	isAdminPlus: false,
	isGisAdmin: false,
	isGisOnly: false,
	projectaccess: [],
	groupaccess: [],
	credentials: {
		username: null,
		token: null
	}
};

export default function login(state = initialState, action) {
	
	switch (action.type) {
		case "SET_LOGIN_DATA":
			return update(state, { $set: action.loginData });
			
		case "RESET_LOGIN_DATA":
			return update(state, { $set: initialState });
				
		case "SET_CREDENTIALS":
			return update(state, { credentials: {
				token: { $set: action.token }, 
				username: { $set: action.username }
			}});			

		case "IS_FETCHING":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_MESSAGE":
			return update(state, { message: { $set: action.message } });		
		
		// case "SET_PROJECT_ACCESS":
		// 	return update(state, { projectaccess: { $set: action.projectaccess } });

		case "SET_GROUP_ACCESS":
			return update(state, { groupaccess: { $set: action.groupaccess } });

		case "SET_CHOOSEN_BY_USER":
			return update(state, { choosenbyuser: { 
				isMariana: { $set: action.isMariana },
				isBrumadinho: { $set: action.isBrumadinho },
				isAssistenciaTecnica: { $set: action.isAssistenciaTecnica }
			} });
		
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/login/reducer.js